export const DISP_CONSTANTS = {
  SEARCH_HERE: $localize`Search Here`,
};
